module.exports = __webpack_public_path__ + "img/13.8312ef9a.png";